import { BiUpArrowAlt } from "react-icons/bi";
import { GrFormView } from "react-icons/gr";
import { formatCurrency } from "../../../utils/CurrencyUtils";

const TableCheckbox = ({ checked, onChange }) => (
    <input
        type="checkbox"
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 cursor-pointer"
        checked={checked}
        onChange={onChange}
    />
);

export default function CustomerList({
    data,
    clientType,
    selectedItems,
    onSelectAll,
    onSelectItem,
    onSortChange,
    sortField,
    onOpenDetails
}) {

    const columnConfig = {
        students: [
            { key: 'login', label: 'Login' },
            { key: 'name', label: 'Nome' },
            { key: 'grade', label: 'Série' },
            { key: 'credit', label: 'Crédito' },
            { key: 'user_status', label: 'Ativo' }
        ],
        parents: [
            { key: 'login', label: 'Login' },
            { key: 'name', label: 'Nome' },
            { key: 'email', label: 'Email' }
        ],
        employees: [
            { key: 'login', label: 'Login' },
            { key: 'name', label: 'Nome' },
            { key: 'credit', label: 'Crédito' },
            { key: 'user_status', label: 'Ativo' }
        ]
    };

    const columns = columnConfig[clientType];

    const isAllSelected =
        data.length > 0 && selectedItems.length === data.length;

    const getSortIcon = (field) => {
        if (sortField?.field !== field) return null;

        return (
            <BiUpArrowAlt
                className={`ml-2 transition-transform duration-200 ${sortField.direction === 'desc' ? 'rotate-180' : ''
                    }`}
            />
        );
    };

    const isSorted = (field) =>
        sortField?.field === field;

    return (
        <div className="animate-fadeIn">
            <table className="table-fixed w-full text-sm lg:text-base border-collapse divide-y divide-custom_blue shadow-md bg-white">
                <thead>
                    <tr className="bg-custom_blue text-white h-10 font-montserrat text-md">
                        <th className="w-10 px-2">
                            <TableCheckbox checked={isAllSelected} onChange={onSelectAll} />
                        </th>

                        {columns.map(col => (
                            <th
                                key={col.key}
                                onClick={() => onSortChange(col.key)}
                                className={`cursor-pointer select-none`}
                            >
                                <div className="flex items-center justify-center">
                                    {col.label}
                                    {getSortIcon(col.key)}
                                </div>
                            </th>
                        ))}

                        <th className="w-24"></th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(item => (
                        <tr 
                            key={`${clientType}-${item.login}`} 
                            className={`text-center font-montserrat font-medium border-b hover:bg-slate-50 transition-colors text-custom_gray_font leading-8 ${selectedItems.includes(item.login) ? 'bg-blue-50' : ''}`}
                        >
                            <td className="px-2">
                                <TableCheckbox
                                    checked={selectedItems.includes(item.login)}
                                    onChange={() => onSelectItem(item.login)}
                                />
                            </td>

                            {columns.map(col => (
                                <td key={col.key} className="truncate px-2">

                                    {col.key === 'credit'
                                        ? (
                                            <span className={
                                                item.credit >= 0
                                                    ? "text-green-600 font-bold"
                                                    : "text-red-500 font-bold"
                                            }>
                                                {formatCurrency(item.credit)}
                                            </span>
                                        )
                                        : col.key === 'user_status'
                                            ? (
                                                <span className={`px-2 py-0.5 rounded text-xs text-white ${item.user_status
                                                    ? "bg-green-500"
                                                    : "bg-red-400"
                                                    }`}>
                                                    {item.user_status ? "Sim" : "Não"}
                                                </span>
                                            )
                                            : item[col.key]
                                    }

                                </td>
                            ))}

                            <td>
                                <GrFormView
                                    onClick={() => onOpenDetails(item)}
                                    className="cursor-pointer text-slate-500 hover:text-blue-600 scale-200 mx-auto"
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}